import { useMutation } from '@apollo/client'

import {
  UploadFileToS3Document,
  UploadFileToS3Input,
  ValidateOrdersDocument,
  ValidateOrdersMutationVariables,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation UploadFileToS3($file: UploadFileToS3Input!) {
    uploadFileToS3(input: $file) {
      fileName
      mimeType
      id
      url
    }
  }
`

atlas`#graphql
  mutation ValidateOrders(
    $url: String!
    $templateId: ID!
    $settings: ValidateOrdersSettings
    $orderSettings: OrderInputSettings!
  ) {
    validateOrders(
      url: $url
      templateId: $templateId
      settings: $settings
      orderSettings: $orderSettings
    ) {
      validatedOrdersIdentifier
      orders {
        doorId
        orderIdentifier
        poNumber
        skuLineItems {
          colorId
          productId
          quantity
          sizeId
          wholesalePrice
          multiplier
        }
      }
      errors {
        code
        message
        type
      }
    }
  }
`

export const useUploadFileToS3 = (): Function => {
  const [mutation] = useMutation(UploadFileToS3Document, {
    client: atlasClient,
  })

  const uploadFileToS3 = async (file: UploadFileToS3Input): Promise<object> =>
    await mutation({
      variables: {
        file,
      },
    })

  return uploadFileToS3
}

export const useValidateOrders = (): Function => {
  const [mutation] = useMutation(ValidateOrdersDocument, {
    client: atlasClient,
  })

  const validateOrders = async (
    validateOrdersVars: ValidateOrdersMutationVariables,
  ): Promise<object> =>
    await mutation({
      variables: {
        url: validateOrdersVars.url,
        templateId: validateOrdersVars.templateId,
        settings: validateOrdersVars.settings,
        orderSettings: validateOrdersVars.orderSettings,
      },
    })

  return validateOrders
}
